module.exports = __webpack_public_path__ + "img/right_checked.6c01bc67.png";